import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import RELORecip from "../RELORecip";
//Don't mess with row and col
export const RELO = () => {
  return (
    <header id="relo" className="p-4 my-2 rounded-5 karaokeImg">
      <div className="container">
        <div className="container-fluid text-center fw-bolder h1 mb-4 ">
          R&nbsp; E&nbsp; L&nbsp; O&nbsp; Rally
        </div>
        <div className="row">
          {/**/}
          <div className="col-md-4">
            <img
              src="RELOLogo2026.png"
              className="img-fluid rounded-4 reloLogoBoarder"
              alt="Current RELO Logo"
            />
          </div>

          {/**/}
          <div className="col-md-8 d-flex flex-column justify-content-start align-items-end text-center">
            <h2>Coming Up September 12 Our Annual RELLO RALLY!!!!!</h2>
            <div className="p-2">
              We are once again preparing for our annual RELO Rally, an event
              held each year to honor the memory of our beloved friend, brother,
              son, and confidant, Rick Eckel. This year marks our 12th annual
              rally, a testament to Rick's enduring impact on all of us.
            </div>

            <div className="p-2">
              Rick was truly an amazing soul who touched countless lives during
              his time on Earth. He was always the first to offer a hug, a
              smile, a kind word, or a piece of advice, often before you even
              realized you needed it. His spirit of generosity and support
              continues to inspire us.
            </div>

            <div className="mt-2">
              Our very first event, "My New Journey," took place on September
              21st, 2014, while Rick was still with us, as we rallied to raise
              funds to support his fight for life. Sadly, Rick passed away on
              May 10th, 2015. In true Rick fashion, his legacy lives on through
              the RELO Rally, as we continue to raise money for various
              individuals and organizations.
            </div>
            <div className="container text-center p-4 border border-4 rounded-4 mt-4 relo-grey">
              {" "}
              If you'd like to contribute, there are a few easy ways to
              help: <br /> To donate goods or services for our auctions, please contact{" "}
              <a href="mailto:pjspub1717@gmail.com">
                pjspub1717@gmail.com
              </a>. <br />
              Silent Auction starting 5 PM <br />
              Live Auction 8 PM <br />
              You can add a donation of any amount to your bill when paying by
              card – just let your bartender or server know. We also have
              donation jars available if you prefer to contribute with cash.
              Thank you so much for your generosity and support.
              <br /> Additional details available on our{" "}
              <a href="https://www.facebook.com/PJsPubSpokane"> FaceBook</a>{" "}
              page.
            </div>
          </div>
          <div className="fw-bold p-4 text-center">
            {" "}
            Over the years, we have proudly supported:
          </div>
        </div>

        <div className="d-flex justify-content-center container-fluid back">
          <ul className="list-group relo-grey sm-w-75 lg-w-50 fw-bold ">
            <li className="list-group-item ">2015: Cancer Care Northwest</li>
            <li className="list-group-item ">
              2016: Kayli Alesis Rogers
            </li>
            <li className="list-group-item ">
              2017: National Brain Tumor Society
            </li>
            <li className="list-group-item ">
              2018: Averie Green and Bill Kendrick
            </li>
            <li className="list-group-item ">2019: Angela Ginter</li>
            <li className="list-group-item ">2021: Chrissy Boone</li>
            <li className="list-group-item ">
              2022: American Childhood Cancer of the Inland Northwest
            </li>
            <li className="list-group-item ">2023: Nikki Fiola-Spencer</li>
            <li className="list-group-item ">2024: Kelly Conrad</li>
            <li className="list-group-item ">2025: Tom Millsbuaugh "VFW Tom" and Bruce Jacobs</li>
          </ul>
        </div>
      </div>
      <div>
        <RELORecip />
      </div>
    </header>
  );
};
